export const hasOwnProperty = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);

export const isEmpty = value => {
    if (
        value === "" ||
        value === null ||
        value === undefined ||
        (value !== null && typeof value === "object" && !Object.keys(value).length)
    ) {
        return true;
    } else {
        return false;
    }
};

export const nl2br = (value, option) => {
    if (option === "rm") {
        return value.replace(/\<br\s*\/\>/g, " ");
    }

    if (option === "alter") {
        return value.replace(/\<br\s*\/\>/g, "\n");
    }

    return value.replace(/\n/g, "<br />");
};

// answer 에 etc 객체를 가지고 있는지 없는지 검사한다.
// 거의 대부분에 쓰임
export const hasEtcKey = (value, target) => {
    return value === "etc" && typeof target === "object" && hasOwnProperty(target, "etc");
};

export const tranceferUnicode = str => {
    return str.replace(/(\<|\>|\/)/g, n => {
        switch (n) {
            case "<":
                return "&lt;";
            case ">":
                return "&gt;";
            case "/":
                return "&#47;";
            default:
                return "";
        }
    });
};
